<div class="iframe-content">
  <iframe
    src="https://console.cloud.google.com/storage/browser/kickthe?project=glass-turbine-246813&folder&hl=en-GB&organizationId=232986480026&pli=1"
    id="frame_1"></iframe>
</div>
>
